export default defineAppConfig({
  ui: {
    colors: {
      // Brand-Skala aus tokens.css (@theme static → --color-clarify-50 … 950):
      // alle primary-* Utilities und Nuxt-UI-Komponenten nutzen die Clarify-Farbe.
      primary: 'clarify',
      neutral: 'zinc'
    },
    button: {
      slots: {
        base: 'font-medium transition-all duration-[240ms]'
      }
    }
  }
})
